
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { exportVinListExcel } from './utils/excel-export';


@Component
export default class ExportVin extends Vue {
    @Prop({ default: false }) readonly show!: boolean;
    @Prop({ default: '' }) readonly centerOrBrandName!: string;
    @Prop({ default: 0 }) readonly year!: number;
    @Prop({ default: '' }) readonly monthName!: string;
    @Prop({ default: () => [] }) readonly items!: any[];

    internalShow: boolean = false;

    get marcaName(): string {
        return this.items && this.items.length > 0 && this.items[0].Marca
            ? this.items[0].Marca
            : '';
    }

    get loading() {
        return false;
    }

    get headers() {
        const headers = [
            { text: 'VIN', value: 'vin' },
            { text: 'Año Modelo', value: 'model_year' },
            { text: 'Marca', value: 'Marca' },
            { text: 'Modelo', value: 'ModeloDn' },
            { text: 'Fecha Despacho', value: 'service_date' }
        ];

        if (this.items.some(item => item.dealer)) {
            headers.splice(3, 0, { text: 'Concesionario', value: 'dealer' });
        }

        return headers;
    }

    L(text: string) {
        return text;
    }

    @Watch('show', { immediate: true })
    onPropShowChanged(val: boolean) {
        this.internalShow = val;
    }

    @Watch('internalShow')
    onInternalShowChanged(val: boolean) {
        if (!val) {
            this.$emit('update:show', false);
        }
    }

    closeDialog() {
        this.internalShow = false;
    }

    formatDate(dateStr: string): string {
        if (!dateStr) return '';
        const d = new Date(dateStr);
        const day = ('0' + d.getDate()).slice(-2);
        const month = ('0' + (d.getMonth() + 1)).slice(-2);
        const year = d.getFullYear();
        return `${day}-${month}-${year}`;
    }

    exportToExcel() {
        const headers = this.headers.map(h => h.text);
        const rows = this.items.map(item => {
            const baseRow = {
                VIN: item.vin,
                "Año Modelo": item.model_year,
                Marca: item.Marca,
                Modelo: item.ModeloDn,
                "Fecha Despacho": this.formatDate(item.service_date)
            };

            if (item.dealer) {
                baseRow['Concesionario'] = item.dealer;
            }

            return baseRow;
        });

        const excelData = {
            title_download: 'Lista de Despachos (VIN) - ' + this.centerOrBrandName + ' - ' + this.year + ' - ' + this.monthName,
            title: this.centerOrBrandName,
            year: this.year,
            monthName: this.monthName,
            columnsCount: headers.length,
            headers: headers,
            rows: rows
        };

        exportVinListExcel.call(this, excelData);
    }

}
